// CashTab's read (finance-real, the user 2026-10-23): main's Cash view with what clients owe and what the team is owed
// for work done to today from jobs, claims and invoices, and where we stand moved by it.
import type { UseQueryResult } from "@tanstack/react-query";
import { useJobsCashView } from "../../hooks/useAgencyTabs";
import type { AgencyCashView, CashDays } from "../../types";

export type CashTabModel = UseQueryResult<AgencyCashView>;

export function useCashTab(days: CashDays): CashTabModel {
  return useJobsCashView(days);
}
